import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      {...props} />
  );
}

function SkeletonCard({ className, ...props }) {
  return (
    <div
      className={cn(
        "rounded-xl border border-white/10 bg-white/[0.03] p-5 shadow-sm shadow-black/20",
        className,
      )}
      {...props}
    >
      <Skeleton className="h-3 w-28 bg-white/10" />
      <Skeleton className="mt-4 h-8 w-36 bg-white/10" />
      <Skeleton className="mt-4 h-3 w-24 bg-white/10" />
    </div>
  );
}

function SkeletonRow({ className, ...props }) {
  return (
    <div
      className={cn(
        "grid grid-cols-[2fr_1.4fr_0.8fr_1fr_1fr_1fr_0.8fr] items-center gap-3 rounded-lg border border-white/5 px-4 py-3",
        className,
      )}
      {...props}
    >
      <Skeleton className="h-4 w-full bg-white/10" />
      <Skeleton className="h-4 w-full bg-white/10" />
      <Skeleton className="h-4 w-full bg-white/10" />
      <Skeleton className="h-4 w-full bg-white/10" />
      <Skeleton className="h-4 w-full bg-white/10" />
      <Skeleton className="h-4 w-full bg-white/10" />
      <Skeleton className="h-4 w-full bg-white/10" />
    </div>
  );
}

export { Skeleton, SkeletonCard, SkeletonRow }
